/**
 * Toaster — rendert alle aktiven Toasts fixed bottom-right.
 * Wird einmal in App.tsx gemountet.
 */

import { dismissToast, useToasts, type ToastKind } from '../lib/toast'

const KIND_STYLES: Record<ToastKind, { border: string; bg: string; eyebrow: string }> = {
  success: {
    border: 'var(--accent)',
    bg: 'var(--accent-soft)',
    eyebrow: 'var(--accent-2)',
  },
  info: {
    border: 'var(--ink-2)',
    bg: 'var(--surface)',
    eyebrow: 'var(--ink-3)',
  },
  error: {
    border: 'var(--bad)',
    bg: 'var(--bad-soft)',
    eyebrow: 'var(--bad)',
  },
}

const KIND_LABEL: Record<ToastKind, string> = {
  success: 'ok',
  info: 'info',
  error: 'fehler',
}

export function Toaster() {
  const toasts = useToasts()
  if (toasts.length === 0) return null
  return (
    <div
      className="toaster"
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 70,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        maxWidth: 'calc(100vw - 32px)',
        pointerEvents: 'none',
      }}
    >
      {toasts.map((t) => {
        const s = KIND_STYLES[t.kind]
        return (
          <div
            key={t.id}
            className="toast"
            style={{
              pointerEvents: 'auto',
              minWidth: 220,
              maxWidth: 380,
              padding: '10px 12px',
              background: s.bg,
              border: '1px solid var(--line)',
              borderLeft: `3px solid ${s.border}`,
              borderRadius: 10,
              boxShadow: '0 10px 28px -16px rgba(31,21,14,0.20)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
            }}
            role="status"
            aria-live="polite"
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                className="mono"
                style={{
                  fontSize: 9.5,
                  color: s.eyebrow,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  fontWeight: 600,
                  marginBottom: 3,
                }}
              >
                {KIND_LABEL[t.kind]}
              </div>
              <div style={{ fontSize: 13, fontWeight: 500, lineHeight: 1.35, color: 'var(--ink)' }}>
                {t.message}
              </div>
            </div>
            <button
              type="button"
              onClick={() => dismissToast(t.id)}
              aria-label="schließen"
              style={{
                background: 'transparent',
                border: 0,
                cursor: 'pointer',
                color: 'var(--ink-3)',
                fontSize: 14,
                padding: 2,
                lineHeight: 1,
                flexShrink: 0,
              }}
            >
              ✕
            </button>
          </div>
        )
      })}
    </div>
  )
}
